import React, { useMemo } from 'react';
import { usePlan } from "../../../../../contexts/PlanOperationContext/Plan";
import { datetime } from '../../../../../util/library/datetime';
import { aDayMillisecond } from "../../../../../util/varibles/constants";
import { HEIGHT_PER_DAY } from "../Operations/constants";
import styles from './style.module.scss';

interface IProps {
    vesselId: string
    isAccessFull: boolean

    onMouseDown(time: number, e: any): void
}

const Days: React.FC<IProps> = ({ vesselId, isAccessFull, onMouseDown }) => {
    const [startPoint] = usePlan(state => state.startCalendar)
    const [finishPoint] = usePlan(state => state.endCalendar)

    const count = useMemo(() => datetime(finishPoint).diff(startPoint, 'day'), [startPoint, finishPoint])

    const style = { marginBottom: (HEIGHT_PER_DAY - 1) + 'px' };

    const list = useMemo(() => {
        const list: number[] = [];
        for (let i = 0; i <= count; i++) {
            const time = startPoint + (i * aDayMillisecond);
            list.push(time);
        }
        return list;
    }, [count, startPoint])

    return <>
        {list.map(time => <div
            className={styles.day}
            style={style}
            key={time}
            data-date={time}
            data-access-full={isAccessFull}
            data-vessel-id={vesselId}
            onMouseDown={(e) => onMouseDown(time, e)}
        />)}
    </>;
};

export default Days;